const r={Information:"information",Success:"success",Progress:"progress",Waiting:"waiting",Caution:"caution",Error:"error"};export{r as messageType};
